import React, { useState, useRef } from "react";
import "./ConfusedAbout.css";
import confusedImg from "../../assets/Image/NewImages/A.jpeg";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";

function ConfusedAbout() {
  const [captchaValue, setCaptchaValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const recaptchaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    if (!captchaValue) {
      setErrorMsg("Please verify the captcha!");
      return;
    }

    try {
      setLoading(true);

      await emailjs.sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      );

      setSuccessMsg("Form submitted successfully!");
      e.target.reset();

      setCaptchaValue(null);
      recaptchaRef.current.reset();
    } catch {
      setErrorMsg("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="confused-section">
      {/* TOP TEXT */}

      <div className="confused-header">
        <h1>
          <span>Confused</span> about 
          career choices?
        </h1>

        <p className="sub-text">
          Avail Career Counselling from India's best Career Experts
        </p>

        <p className="trusted-text">
          Trusted by Students and Institutions Across India
        </p>
      </div>

      {/* TWO BOX LAYOUT */}

      <div className="confused-container">
        {/* LEFT FORM */}

        <div className="form-box">
          <form onSubmit={handleSubmit}>
            <h3>Request a call back</h3>

            <input
              type="text"
              name="full_name"
              placeholder="Full Name"
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
            />

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              pattern="[0-9]{10}"
              required
            />

            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={(value) => setCaptchaValue(value)}
            />

            {errorMsg && <p className="error-msg">{errorMsg}</p>}
            {successMsg && <p className="success-msg">{successMsg}</p>}

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>

        {/* RIGHT IMAGE */}

        <div className="image-box">
          <img src={confusedImg} alt="Career Guidance" />

          <Link to="/about">
            <button className="about-btn">Know More About Us</button>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ConfusedAbout;
